import { getRouter } from '@/utils/navigationUtils';
import appMarketAggregator from '@/modules/appMarket/utils/appMarketAggregator';

let inFlightPromise = null;

const state = {
  apps: [],
  loaded: false,
  enteredInfoFromMarket: false,
};

const getters = {
  marketApps: (state) => state.apps,
  marketAppsLoaded: (state) => state.loaded,
  visibleMarketApps: (state) => state.apps.filter((app) => app.is_listed),
  marketAppByCodeName: (state) => (appCodeName) => state.apps.find((app) => app.app_code_name === appCodeName),
  enteredInfoFromMarket: (state) => state.enteredInfoFromMarket,
};

const mutations = {
  setApps(state, apps) {
    state.apps = apps;
  },
  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setEnteredInfoFromMarket(state, value) {
    state.enteredInfoFromMarket = value;
  },
};

const actions = {
  // Reads the catalog and subscriptions as loaded; AppsStore/refreshAppsAfterStatusChange refreshes them.
  async fetchMarketApps({
    state, commit, dispatch, rootGetters,
  }, { force = false } = {}) {
    if (state.loaded && !force) return state.apps;
    // A forced call replaces the in-flight reference without cancelling it; the newer result wins.
    if (inFlightPromise && !force) return inFlightPromise;

    const promise = (async () => {
      try {
        const [offerings] = await Promise.all([
          dispatch('OfferingStore/fetchAppOfferings', undefined, { root: true }),
          dispatch('SubscriptionStore/fetchActiveSubscriptions', undefined, { root: true }),
          dispatch('AppsStore/loadApps', undefined, { root: true }),
          dispatch('AccountStore/getAccountCurrency', null, { root: true }),
        ]);

        const apps = appMarketAggregator.aggregateMarketApps({
          apps: rootGetters['AppsStore/marketApps'].map((app) => ({ ...app })),
          offerings,
          subscriptions: rootGetters['SubscriptionStore/activeSubscriptions'],
          geoData: rootGetters['AccountStore/geoData'],
        });

        commit('setApps', apps);
        commit('setLoaded', true);
        return apps;
      } finally {
        if (inFlightPromise === promise) inFlightPromise = null;
      }
    })();

    inFlightPromise = promise;
    return promise;
  },
  backToMarket({ state, commit }) {
    if (state.enteredInfoFromMarket) {
      commit('setEnteredInfoFromMarket', false);
      getRouter().go(-1);
    } else {
      getRouter().replace({ name: 'appMarket' });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
